// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6aefbd99","492":"bc6b2bfb"}[chunkId] + ".chunk.js";
};